import React from "react";
import { motion } from "framer-motion";
import { Wrench, Settings2, Hammer, ArrowUpRight } from "lucide-react";

const services = [
  {
    icon: Wrench,
    title: "Instalación",
    description:
      "Montaje profesional de equipos residenciales y comerciales con garantía y certificación técnica.",
    points: ["Equipos residenciales", "Instalación comercial", "Garantía total"],
  },
  {
    icon: Settings2,
    title: "Mantenimiento",
    description:
      "Servicio preventivo periódico para prolongar la vida útil de tu equipo y optimizar el consumo.",
    points: ["Limpieza profunda", "Revisión técnica", "Plan mensual / anual"],
  },
  {
    icon: Hammer,
    title: "Reparación",
    description:
      "Diagnóstico y reparación rápida de fallas en cualquier marca de aire acondicionado.",
    points: ["Diagnóstico inmediato", "Repuestos originales", "Servicio express"],
  },
];

export const Services = () => {
  return (
    <section
      id="servicios"
      data-testid="services-section"
      className="relative bg-jr-gray-bg py-16 md:py-32 overflow-hidden"
    >
      {/* Top wave */}
      <svg
        className="absolute top-0 left-0 w-full h-20 -translate-y-px"
        viewBox="0 0 1440 80"
        preserveAspectRatio="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 0 L1440 0 L1440 40 Q1080 80 720 40 T0 40 Z"
          fill="#FFFFFF"
        />
      </svg>


      <div className="container-jr relative">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-50px" }}
          transition={{ duration: 0.4 }}
          className="text-center max-w-2xl mx-auto mb-16"
        >
          <h2
            className="mt-4 font-display font-semibold text-jr-oxford text-[28px] md:text-[40px] lg:text-[46px] leading-[1.1] tracking-[-0.02em]"
            data-testid="services-title"
          >
            Servicios que ofrecemos
          </h2>
          <p className="mt-5 text-jr-gray-text text-[16px] leading-relaxed">
            Soluciones integrales en climatización para que disfrutes del clima
            perfecto en tu hogar o negocio.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {services.map((service, i) => (
            <motion.article
              key={service.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.4, delay: i * 0.06 }}
              className="group relative bg-white rounded-2xl p-6 lg:p-8 shadow-jr-card hover:shadow-jr-card-hover hover:-translate-y-2 transition-all duration-300 border-t-4 border-jr-cyan"
              data-testid={`service-card-${service.title.toLowerCase()}`}
            >
              {/* Icon */}
              <div className="w-14 h-14 rounded-2xl bg-jr-oxford/10 flex items-center justify-center mb-6 group-hover:bg-jr-cyan/15 transition-colors duration-300">
                <service.icon size={26} className="text-jr-yale group-hover:text-jr-cyan transition-colors duration-300" strokeWidth={1.75} />
              </div>

              <h3 className="font-display font-semibold text-jr-oxford text-[20px] md:text-[22px] tracking-tight">
                {service.title}
              </h3>
              <p className="mt-3 text-jr-gray-text text-[15px] leading-relaxed">
                {service.description}
              </p>

              {/* Points */}
              <ul className="mt-6 space-y-2.5">
                {service.points.map((p) => (
                  <li key={p} className="flex items-center gap-2.5 text-jr-oxford text-[13px] font-medium">
                    <span className="w-1.5 h-1.5 rounded-full bg-jr-cyan flex-shrink-0" />
                    {p}
                  </li>
                ))}
              </ul>

              {/* Decorative arrow */}
              <div className="absolute top-7 right-7 w-9 h-9 rounded-full border border-jr-gray-bg flex items-center justify-center group-hover:bg-jr-cyan group-hover:border-jr-cyan transition-all duration-300">
                <ArrowUpRight
                  size={16}
                  className="text-jr-yale group-hover:text-white transition-colors duration-300"
                />
              </div>
            </motion.article>
          ))}
        </div>
      </div>

      {/* Bottom wave */}
      <svg
        className="absolute bottom-0 left-0 w-full h-16 translate-y-px"
        viewBox="0 0 1440 60"
        preserveAspectRatio="none"
      >
        <path
          d="M0 60 L1440 60 L1440 20 Q1080 -20 720 20 T0 20 Z"
          fill="#FFFFFF"
        />
      </svg>
    </section>
  );
};

export default Services;
